import React from 'react'

import { Box, Color, Display, FlexDirection, FontWeight, Text } from '@gousto-internal/citrus-react'

import { ProductItem } from './ProductItem'
import type { BasketUpsellProduct, BasketUpsellProductActionSource } from './BasketUpsell/types'

type ProductsProps = {
  products: BasketUpsellProduct[]
  onClickProduct: (product: BasketUpsellProduct) => void
  onAddProduct: (productId: string, source: BasketUpsellProductActionSource) => void
  onRemoveProduct: (productId: string, source: BasketUpsellProductActionSource) => void
}

export const Products = ({
  products,
  onAddProduct,
  onClickProduct,
  onRemoveProduct,
}: ProductsProps) => {
  if (!products.length) return null

  return (
    <Box
      data-testid="products"
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={3}
      paddingBottom={4}
    >
      <Box display={Display.Flex} gap={2} color={Color.ColdGrey_900}>
        <Text fontWeight={FontWeight.Bold}>Gousto Market</Text>
      </Box>
      {products.map((product) => (
        <ProductItem
          key={product.id}
          product={product}
          onAddProduct={onAddProduct}
          onClickProduct={onClickProduct}
          onRemoveProduct={onRemoveProduct}
        />
      ))}
    </Box>
  )
}
